import { lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import App from '../App';
import PaymentStatusPage from '../pages/PaymentStatusPage';

export default function AppRoutes() {
    const CheckoutPage = lazy(() => import('../pages/CheckoutPage'));
    const CheckoutEXPage = lazy(() => import('../pages/CheckoutEXPage'));
    const ApplicationPage = lazy(() => import('../pages/ApplicationPage'));

    return (
        <BrowserRouter basename={'/'}>
            <Routes>
                <Route element={<App />}>
                    <Route path='/checkout/:key' element={<CheckoutPage />} />
                    <Route path='/checkoutex/:key' element={<CheckoutEXPage />} />
                    <Route path='/application/:key' element={<ApplicationPage />} />
                    <Route path='/payment/:status/:refNo' element={<PaymentStatusPage />} />
                    <Route index path='/' element={`Unauthorized`} />
                    <Route path='*' element={<Navigate to="/"/>} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}